import React from 'react';
import i18n from '../../i18n';
import borders from '@material-ui/system';
import Button from "@material-ui/core/Button/Button";
import Icon from "@material-ui/core/Icon/Icon";
import Grid from "@material-ui/core/Grid/Grid";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Typography from "@material-ui/core/Typography/Typography";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Divider from "@material-ui/core/Divider/Divider";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import {withStyles} from "@material-ui/core/styles/index";
import Chip from "@material-ui/core/Chip/Chip";
import FormLabel from "@material-ui/core/FormLabel/FormLabel";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import Link from "@material-ui/core/Link/Link";
import Date from "../Formater/Date";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';

class PersonDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTab: 0
        };
    }

    render() {
        const {person, personType, classes} = this.props;

        return (
            <Grid container spacing={16}>
                <Grid item xs={4}>
                    <Card>
                        <CardContent>
                            <Grid container spacing={8}>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.title')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.title}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.first_name')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.first_name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.last_name')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.last_name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.gender')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.gender}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.birthday')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    {person.birthday &&
                                    <Typography>
                                        <Date value={person.birthday}/>
                                    </Typography>
                                    }
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.citizenship')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.citizenship}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.denomination')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.denomination}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Divider className={classes.gridDivider}/>

                            <Grid container spacing={8}>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.address')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.street} {person.housenumber}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.zip')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.zip}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.city')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.city}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.telephone')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.telephone}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.mobile')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.mobile}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.email')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.email}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.website')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.website}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Divider className={classes.gridDivider}/>

                            <Grid container spacing={8}>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.company')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    {person.board &&
                                    <Typography component='div'>
                                        <Link
                                            href={`/boards/${person.board.id}`}
                                            color="inherit"
                                            className={classes.boardLink}
                                        >
                                            <EllipsisWithTooltip>
                                                {person.board.board_name}
                                            </EllipsisWithTooltip>
                                        </Link>
                                    </Typography>
                                    }
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('persons.department')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {person.department}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Divider className={classes.gridDivider}/>

                            <FormLabel component="h3">{i18n.get('persons.qualifications')}:</FormLabel>
                            {person.lecturer_qualifications_with_qualification.map(lecturerQualification => (
                                <Chip
                                    // variant="outlined"
                                    label={lecturerQualification.qualification.name}
                                    className={classes.chipQuali}
                                />
                            ))}
                        </CardContent>
                    </Card>
                </Grid>
                {personType === 'lecturer' &&
                <React.Fragment>
                    <Grid item xs={4}>
                        <Card>
                            <CardContent>
                                <FormLabel component="h3">{i18n.get('persons.contracts')}:</FormLabel>
                                <List>
                                    {person.contracts.map(contract => (
                                        <ListItemText key={contract.id}>
                                            <Typography component='div'>
                                                <Link
                                                    href={`/contracts/${contract.id}`}
                                                    color="inherit"
                                                >
                                                    <EllipsisWithTooltip>
                                                        {contract.course.name}
                                                    </EllipsisWithTooltip>
                                                </Link>
                                            </Typography>
                                        </ListItemText>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={4}>
                        <Card>
                            <CardContent>
                                <FormLabel component="h3">{i18n.get('persons.invoices')}:</FormLabel>
                                <List>
                                    {person.invoices.map(invoice => (
                                        <ListItemText key={invoice.id}>
                                            <Typography component='div'>
                                                <Link
                                                    href={`/invoice/person/${invoice.id}`}
                                                    color="inherit"
                                                >
                                                    <EllipsisWithTooltip>
                                                        <FontAwesomeIcon
                                                            icon={faFileInvoiceDollar}/> {invoice.course.name}
                                                        <Date value={invoice.invoice_date}/>
                                                    </EllipsisWithTooltip>
                                                </Link>
                                            </Typography>
                                        </ListItemText>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </React.Fragment>
                }
            </Grid>
        )
    }
}

const styles = {
    personCard: {
        width: '500px',
        margin: 'auto',
    },
    gridDivider: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    linkBoard: {
        backgroundColor: 'grey',
    },
    chipQuali: {
        margin: '5px',
    }
};

export default withStyles(styles)(PersonDetails);


// WEBPACK FOOTER //
// ./resources/assets/js/components/Persons/PersonsDetails.js